import "./hb-pixxikat.module.css";
import { html } from "lit-html";
import { isPopup } from "../../global";

export default (user) => html`
    <div
        id="hb-pixxikat"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <a
                        href="https://dpixxi.com"
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        🤎 B-Emoji: Pixxikat™
                    </a>
                    <aside>
                        <button
                            type="button"
                            class="${isPopup
                                ? "hidden"
                                : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="hb-pixxikat">
                            <svg
                                class="w-4 h-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 384 512">
                                <path
                                    d="M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z" />
                            </svg>
                            <span class="sr-only">Close</span>
                        </button>
                    </aside>
                </div>
                <!-- Modal body -->
                <form
                    id="hb-pixxikat-form"
                    class="p-4 md:p-5 space-y-4 text-base leading-[2] text-gray-900 dark:text-white">
                    <div class="grid gap-4">
                        <div>
                            <div class="relative w-full mb-1">
                                <div
                                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                                    </svg>
                                </div>
                                <input
                                    autocomplete="off"
                                    data-dropdown-toggle2="hb-pixxikat-stock-categories"
                                    data-dropdown-delay="500"
                                    data-dropdown-trigger2="hover"
                                    type="text"
                                    id="hb-pixxikat-stock-search"
                                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Search for Pixxikat™ B-Emoji" />
                                <button
                                    type="button"
                                    id="hb-pixxikat-stock-magic"
                                    type="button"
                                    class="absolute inset-y-0 end-0 flex items-center pe-3">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2 .5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0 172.4-82.5 213.2-264 213.6-363.2 .1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4l.2 0c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3l.2 0c5.8 0 10.4 4.7 10.4 10.4L352 272c0 53-43 96-96 96s-96-43-96-96l0-117.6zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z" />
                                    </svg>
                                </button>
                                <div
                                    id="hb-pixxikat-stock-categories"
                                    class="z-10 overflow-y-scroll h-52 hidden absolute bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-full dark:bg-gray-700">
                                    <ul
                                        class="py-2 text-sm text-gray-700 dark:text-gray-200"
                                        aria-labelledby="hb-pixxikat-stock-search"></ul>
                                </div>
                            </div>
                        </div>
                        <div
                            id="hb-pixxikat-stock"
                            class="grid w-full h-auto grid-cols-3 gap-3"></div>
                    </div>
                    <!-- Modal footer: Mint Emoji -->
                    <div
                        class="flex items-center justify-between p-2 border-0 border-amber-200 rounded-b dark:border-amber-600">
                        <button
                            type="submit"
                            class="mr-1 text-white bg-amber-800 hover:bg-amber-800 focus:ring-4 focus:outline-none focus:ring-amber-300 font-medium rounded-lg text-sm w-full px-3 py-2.5 text-center dark:bg-amber-700 dark:hover:bg-amber-700 dark:focus:ring-amber-800">
                            Share Pixxikat™
                        </button>
                        <button
                            id="hb-pixxikat-copy"
                            type="button"
                            class="ml-1 text-white bg-amber-800 hover:bg-amber-800 focus:ring-4 focus:outline-none focus:ring-amber-300 font-medium rounded-lg text-sm w-full px-3 py-2.5 text-center dark:bg-amber-700 dark:hover:bg-amber-700 dark:focus:ring-amber-800">
                            Copy Pixxikat™
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
`;
